import { render, staticRenderFns } from "./AnimatedAudioBars.vue?vue&type=template&id=4ccc8930&scoped=true&"
import script from "./AnimatedAudioBars.vue?vue&type=script&lang=ts&"
export * from "./AnimatedAudioBars.vue?vue&type=script&lang=ts&"
import style0 from "./AnimatedAudioBars.vue?vue&type=style&index=0&id=4ccc8930&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccc8930",
  null
  
)

export default component.exports